import { treaty } from '@elysiajs/eden';
import type { App } from '@pricedrop/server/app';
import { getBaseURL } from './base-url';

/**
 * Bearer-bound Eden client for extension-originated requests.
 *
 * Used by /embed/* routes that receive a token via the postMessage bridge
 * (see useExtensionAuth). Separate from `./api.ts` (cookie-bound) to prevent
 * accidental double-authentication and to make the auth mode explicit at each
 * call site.
 *
 * The extension is a cross-origin caller — `credentials: 'omit'` is
 * deliberate: bearer is the only auth channel.
 *
 * `getToken` is a getter (not a fixed value) so the token can be refreshed
 * after client creation without rebuilding the client — the closure reads
 * the current value on every outbound request.
 */
export function createExtensionApi(getToken: () => string | null) {
  return treaty<App>(getBaseURL(), {
    fetch: {
      credentials: 'omit',
    },
    onRequest(_path, init) {
      const token = getToken();
      if (!token) return;
      return {
        ...init,
        headers: {
          ...(init.headers ?? {}),
          authorization: `Bearer ${token}`,
        },
      };
    },
  });
}
